import { useTranslation } from "react-i18next";

import useNotification from "../components/notifications/useNotifications";


export default function useDefaultCRUDHandlers(objectName) {
  const { t } = useTranslation("common");
  const { addNotification } = useNotification();

  const saveHandlers = {
    onSuccess: () => {
      addNotification({
        variant: "success",
        primaryText: t("{{name}} saved", { name: objectName }),
      });
    },
    onError: () => {
      addNotification({
        variant: "error",
        primaryText: t("Failed to save {{name}}", { name: objectName.toLowerCase() }),
      });
    },
  }

  const deleteHandlers = {
    onSuccess: () => {
      addNotification({
        variant: "success",
        primaryText: t("{{name}} deleted", { name: objectName }),
      });
    },
    onError: () => {
      addNotification({
        variant: "error",
        primaryText: t("Failed to delete {{name}}", { name: objectName.toLowerCase() }),
      });
    },
  }

  return {
    saveHandlers,
    deleteHandlers
  }
}